

























































































import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
declare let PARTNER_MODE: boolean;
declare let PARTNER_ID: string;

@Component({
  name: 'create-instant-modal',
  components: {
    TButton
  }
})
export default class CreateWalkthroughModal extends Vue {
  private partnerMode = PARTNER_MODE;
  private partnerId = PARTNER_ID;

  get engagementToken() {
    return this.$user && this.$user.state.engagementToken;
  }

  get queryParams() {
    return this.engagementToken ? `?et=${this.engagementToken}` : '';
  }

  get videoTutorialUrl() {
    return `https://wiki.portal.trainn.co/share/bf93c553-3d4d-45b9-be04-5cf131d871df${this.queryParams}`;
  }
}
